import { Component } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import PropTypes from "prop-types";

export default class SlideInLoader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let style = {
      position: "fixed",
      width: "80px",
      height: "80px",
      right: "0px",
      transition: "right 0.5s",
      top: "80%",
      zIndex: "99",
    };

    if (this.props.open) {
      style.right = "0px";
    } else {
      style.right = "-80px";
    }

    return (
      <div style={style}>
        <Card containerStyle={{ backgroundColor: "#565656" }}>
          <CardContent>
            {!this.props.open ? (
              <div />
            ) : (
              <CircularProgress
                size={50}
                thickness={7}
                color="rgb(255, 147, 0)"
              />
            )}
          </CardContent>
        </Card>
      </div>
    );
  }

  static propTypes = {
    onRefreshClick: PropTypes.func,
    timeOut: PropTypes.number,
  };
}
